import React from 'react';
import styled from '@emotion/styled';
import { Box, Flex, Icon } from '@qga/roo-ui/components';

import CollapsiblePackageSection, {
  Heading,
} from '@shared/v2/components/CollapsiblePackageSection';
import { SkeletonProvider } from '@shared/v2/components/Skeleton';

import CampaignAppliedNotification from '@/v2/components/pages/PackageViewV2/components/CampaignAppliedNotification';
import UnavailableWarning from '@/v2/components/pages/PackageViewV2/components/UnavailableWarning';
import { useOtherPackageModal } from '@/v2/components/pages/PackageViewV2/contexts/OtherPackageModalContext';
import { usePackagePageV3 } from '@/v2/hooks/featureFlags/packagePageV3/usePackagePageV3';
import { useRoomOptionsData } from '../../contexts/RoomOptionsContext';
import OtherPackageModal from '../OtherPackageModal';
import MainRooms from './components/MainRooms';
import OtherRooms from './components/OtherRooms';
import SearchPanel from './components/SearchPanel';

const HeadingContainer = styled(Flex)`
  gap: 4px;
`;

const MessageContainer = styled(Flex)`
  & > *:last-child {
    margin-bottom: 24px;
  }
`;

const RoomOptions = () => {
  const { roomOptions, isLoading } = useRoomOptionsData() || {};
  const isPackagePageV3Enabled = usePackagePageV3();
  const { closeOtherPackageModal, isOtherPackageModalOpen } =
    useOtherPackageModal();

  return (
    <SkeletonProvider isLoading={isLoading}>
      <CollapsiblePackageSection
        isOpen
        showButton={false}
        icon={
          <Icon name="stay" color="primary" size={['42px', null, '56px']} />
        }
        headerContent={
          <HeadingContainer
            flexDirection="column"
            justifyContent="space-between"
          >
            <Heading isBig>Room options</Heading>
            <Heading>
              Select travel dates and travellers to see package pricing
            </Heading>
          </HeadingContainer>
        }
        sectionContent={
          <Flex
            pt="2"
            pb={['2', null, '0']}
            flexDirection={['column', null, 'row']}
            gap="24px"
          >
            <Flex flex="1" flexDirection="column">
              <MessageContainer
                display={['flex', null, 'none']}
                gap="12px"
                flexDirection="column"
              >
                <CampaignAppliedNotification mb="0" />
                <UnavailableWarning />
              </MessageContainer>
              <MainRooms roomOptions={roomOptions?.main} />
              <OtherRooms
                roomOptions={roomOptions?.other}
                roomIndexOffset={roomOptions?.main?.length || 0}
              />
            </Flex>
            <Box flex="0 1 424px" display={['none', null, 'block']}>
              <SearchPanel />
            </Box>
          </Flex>
        }
      />
      {isPackagePageV3Enabled && (
        <OtherPackageModal
          isOpen={isOtherPackageModalOpen}
          onClose={closeOtherPackageModal}
        />
      )}
    </SkeletonProvider>
  );
};

export default RoomOptions;
